export const ShieldIcon = (props: any) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='42.18'
      height='49.532'
      viewBox='0 0 42.18 49.532'
      style={props.style}>
      <g id='surface1' transform='translate(0 0.001)'>
        <path
          id='Caminho_3'
          data-name='Caminho 3'
          d='M42.131,13.438V13.4c-.022-.476-.036-.979-.045-1.539a5.25,5.25,0,0,0-4.943-5.143A20.371,20.371,0,0,1,23.277.874L23.245.843a3.17,3.17,0,0,0-4.308,0L18.9.874A20.373,20.373,0,0,1,5.039,6.718,5.249,5.249,0,0,0,.1,11.861c-.008.556-.023,1.06-.045,1.539l0,.089C-.061,19.3-.2,26.524,2.219,33.084A24.943,24.943,0,0,0,8.2,42.405a31.3,31.3,0,0,0,11.71,6.927,3.627,3.627,0,0,0,.48.131,3.545,3.545,0,0,0,1.394,0,3.639,3.639,0,0,0,.482-.131,31.324,31.324,0,0,0,11.7-6.93,24.978,24.978,0,0,0,5.984-9.323C42.378,26.5,42.241,19.257,42.131,13.438ZM37.224,32.072c-2.55,6.914-7.756,11.662-15.914,14.516a.729.729,0,0,1-.092.025.652.652,0,0,1-.255,0,.723.723,0,0,1-.092-.025C12.7,43.739,7.495,38.994,4.947,32.079,2.718,26.032,2.844,19.4,2.956,13.545v-.033c.023-.5.038-1.03.046-1.609A2.333,2.333,0,0,1,5.2,9.62a25.5,25.5,0,0,0,8.655-1.9,22.645,22.645,0,0,0,7.054-4.739.268.268,0,0,1,.36,0,22.654,22.654,0,0,0,7.054,4.739,25.5,25.5,0,0,0,8.656,1.9,2.333,2.333,0,0,1,2.2,2.284c.009.582.024,1.109.046,1.608C39.336,19.372,39.459,26.012,37.224,32.072Zm0,0'
          transform='translate(0)'
          fill='#e20c18'
        />
        <path
          id='Caminho_4'
          data-name='Caminho 4'
          d='M102.743,128.41a12.344,12.344,0,1,0,12.344,12.344A12.358,12.358,0,0,0,102.743,128.41Zm0,21.782a9.438,9.438,0,1,1,9.437-9.438A9.448,9.448,0,0,1,102.743,150.192Zm0,0'
          transform='translate(-81.653 -115.988)'
          fill='#e20c18'
        />
        <path
          id='Caminho_5'
          data-name='Caminho 5'
          d='M163.443,212.417l-5.734,5.733-1.556-1.556a1.453,1.453,0,0,0-2.055,2.055l2.584,2.584a1.453,1.453,0,0,0,2.055,0l6.761-6.761a1.453,1.453,0,0,0-2.055-2.055Zm0,0'
          transform='translate(-138.806 -191.483)'
          fill='#e20c18'
        />
      </g>
    </svg>
  );
};

export const CursorIcon = (props: any) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='39.609'
      height='55.738'
      viewBox='0 0 39.609 55.738'
      style={props.style}>
      <g id='touch' transform='translate(0.001 0)'>
        <path
          id='Caminho_6'
          data-name='Caminho 6'
          d='M9.92,35.1a4.14,4.14,0,0,0-4.74-6.649,16.573,16.573,0,0,1-3-9.566A16.743,16.743,0,0,1,17.935,2.177,1.089,1.089,0,1,0,17.809,0,18.924,18.924,0,0,0,0,18.887,18.733,18.733,0,0,0,3.535,29.9,4.139,4.139,0,0,0,9.92,35.1ZM5.606,30.789a1.961,1.961,0,1,1,0,2.773,1.955,1.955,0,0,1,0-2.773Zm0,0'
          transform='translate(0 0)'
          fill='#e20c18'
        />
        <path
          id='Caminho_7'
          data-name='Caminho 7'
          d='M85.84,49.7a3.871,3.871,0,0,0-1.9.494,3.895,3.895,0,0,0-6.525-1.53,3.946,3.946,0,0,0-.653-.544,18.922,18.922,0,0,0,11.2-17.272,18.743,18.743,0,0,0-3.535-11.013,4.142,4.142,0,1,0-1.646,1.445,16.745,16.745,0,0,1-9.889,25.863V41.279A11.118,11.118,0,1,0,57.927,30.847,11.026,11.026,0,0,0,60.136,37.5,11.232,11.232,0,0,0,65.1,41.24V57.263l-1.368-2.245a4.012,4.012,0,0,0-5.464-1.4,4.055,4.055,0,0,0-1.612,5.26l4.063,8.209a1.089,1.089,0,0,0,1.953-.966l-4.059-8.2a1.858,1.858,0,0,1,3.259-1.775l3.388,5.558a1.089,1.089,0,0,0,2.02-.567V36.151a1.718,1.718,0,0,1,3.437,0v4.309c0,.008,0,.015,0,.023V56.838a1.089,1.089,0,0,0,2.179,0V51.364a1.718,1.718,0,1,1,3.436,0v5.871a1.089,1.089,0,1,0,2.179,0V51.364a1.718,1.718,0,1,1,3.436,0v5.945a1.089,1.089,0,1,0,2.179,0V53.6a1.718,1.718,0,0,1,3.437,0V66.608a1.089,1.089,0,1,0,2.179,0V53.6a3.9,3.9,0,0,0-3.9-3.9ZM79.582,18.945a1.961,1.961,0,1,1,2.773,0,1.963,1.963,0,0,1-2.773,0Zm-19.476,11.9a8.939,8.939,0,1,1,12.786,8.07V36.15a3.87,3.87,0,0,0-.395-1.707,4.988,4.988,0,1,0-6.972-.065A3.872,3.872,0,0,0,65.1,36.15v2.721a8.893,8.893,0,0,1-4.992-8.024Zm6.912,1.947a2.783,2.783,0,0,1-.784-1.947,2.811,2.811,0,1,1,4.8,1.984,3.887,3.887,0,0,0-4.015-.037Zm0,0'
          transform='translate(-50.128 -11.96)'
          fill='#e20c18'
        />
        <path
          id='Caminho_8'
          data-name='Caminho 8'
          d='M200.284,5.745a1.09,1.09,0,1,0-.77-.319A1.1,1.1,0,0,0,200.284,5.745Zm0,0'
          transform='translate(-177.511 -3.178)'
          fill='#e20c18'
        />
      </g>
    </svg>
  );
};

export const ViewIcon = (props: any) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='48.843'
      height='45.779'
      viewBox='0 0 48.843 45.779'
      style={props.style}>
      <g id='ux' transform='translate(-0.001 -0.5)'>
        <path
          id='Caminho_9'
          data-name='Caminho 9'
          d='M46.8,29.978a2.4,2.4,0,1,0-2.4,2.4A2.4,2.4,0,0,0,46.8,29.978Zm-3.368,0a.969.969,0,1,1,.969.968A.97.97,0,0,1,43.431,29.978Zm0,0'
          transform='translate(-37.993 -24.495)'
          fill='#e20c18'
        />
        <path
          id='Caminho_10'
          data-name='Caminho 10'
          d='M104.161,32.377a2.4,2.4,0,1,0-2.4-2.4A2.4,2.4,0,0,0,104.161,32.377Zm0-3.368a.968.968,0,1,1-.968.968A.97.97,0,0,1,104.161,29.009Zm0,0'
          transform='translate(-92.053 -24.495)'
          fill='#e20c18'
        />
        <path
          id='Caminho_11'
          data-name='Caminho 11'
          d='M163.92,32.377a2.4,2.4,0,1,0-2.4-2.4A2.4,2.4,0,0,0,163.92,32.377Zm0-3.368a.968.968,0,1,1-.969.968A.97.97,0,0,1,163.92,29.009Zm0,0'
          transform='translate(-146.111 -24.495)'
          fill='#e20c18'
        />
        <path
          id='Caminho_12'
          data-name='Caminho 12'
          d='M262.883,46.661h17.426a.715.715,0,1,0,0-1.431H262.883a.715.715,0,1,0,0,1.431Zm0,0'
          transform='translate(-237.157 -40.463)'
          fill='#e20c18'
        />
        <path
          id='Caminho_13'
          data-name='Caminho 13'
          d='M45.856.5H2.988A2.991,2.991,0,0,0,0,3.487v39.8a2.991,2.991,0,0,0,2.987,2.987H45.856a2.991,2.991,0,0,0,2.987-2.987V3.487A2.991,2.991,0,0,0,45.856.5Zm0,44.348H2.988a1.558,1.558,0,0,1-1.557-1.557V10.465H5.42a.715.715,0,1,0,0-1.431H1.432V3.488A1.558,1.558,0,0,1,2.988,1.931H45.856a1.558,1.558,0,0,1,1.557,1.557V9.034H8.091a.715.715,0,1,0,0,1.431H47.413V43.292A1.558,1.558,0,0,1,45.856,44.848Zm0,0'
          transform='translate(0 0)'
          fill='#e20c18'
        />
        <path
          id='Caminho_14'
          data-name='Caminho 14'
          d='M98.25,123.66H92a2.268,2.268,0,0,0-2.265,2.265v.866a2.383,2.383,0,0,0-1.546,1.548l-11.175.042a2.383,2.383,0,0,0-1.545-1.543v-.865a2.268,2.268,0,0,0-2.265-2.265H66.947a2.268,2.268,0,0,0-2.265,2.265v6.253a2.268,2.268,0,0,0,2.265,2.265h.865a2.382,2.382,0,0,0,1.546,1.546v2.923a2.739,2.739,0,0,0,2.736,2.736h6.74a2.382,2.382,0,0,0,1.545,1.545v.915a2.219,2.219,0,0,0,2.216,2.216h.969A2.38,2.38,0,0,0,85,147.931a1.252,1.252,0,0,1-1.118.692H76.236a2.381,2.381,0,0,0-1.6-1.741v-.866a2.268,2.268,0,0,0-2.265-2.265H66.119a2.268,2.268,0,0,0-2.265,2.265v6.253a2.267,2.267,0,0,0,2.265,2.265h6.253a2.268,2.268,0,0,0,2.265-2.265V151.4a2.384,2.384,0,0,0,1.473-1.35h7.767A2.686,2.686,0,0,0,86.485,148a2.381,2.381,0,0,0,1.638-1.629h.823a2.218,2.218,0,0,0,2.216-2.216v-1.882a.715.715,0,0,0-1.431,0v1.882a.786.786,0,0,1-.785.785h-.862a2.371,2.371,0,0,0-4.481,0H82.6a.786.786,0,0,1-.785-.785v-.915a2.346,2.346,0,0,0,.438-.189,2.4,2.4,0,0,0,1.218-2.072,2.375,2.375,0,0,0-1.656-2.261V137.8a.786.786,0,0,1,.785-.785h6.351a.786.786,0,0,1,.785.785v1.882a.715.715,0,0,0,1.431,0V137.8a2.219,2.219,0,0,0-2.216-2.216H82.6a2.219,2.219,0,0,0-2.216,2.216v.914a2.382,2.382,0,0,0-1.545,1.545H72.094a1.306,1.306,0,0,1-1.305-1.3v-2.923a2.382,2.382,0,0,0,1.545-1.546H73.2a2.267,2.267,0,0,0,2.265-2.265v-.866a2.381,2.381,0,0,0,1.546-1.548l11.175-.042a2.382,2.382,0,0,0,1.545,1.543v.866A2.268,2.268,0,0,0,92,134.444H98.25a2.268,2.268,0,0,0,2.265-2.265v-6.253a2.268,2.268,0,0,0-2.265-2.265ZM73.922,150.083a.94.94,0,1,1,.94-.94A.941.941,0,0,1,73.922,150.083Zm-.715,2.186a.835.835,0,0,1-.834.834H66.119a.835.835,0,0,1-.834-.834v-6.253a.835.835,0,0,1,.834-.834h6.253a.835.835,0,0,1,.834.834v.866a2.372,2.372,0,0,0,0,4.522Zm13.577-6.548a.94.94,0,0,1-1.88,0A.941.941,0,1,1,86.784,145.721Zm-5.546-5.671a.94.94,0,1,1-1.083.929A.942.942,0,0,1,81.237,140.05ZM74.75,130.039a.94.94,0,1,1,.94-.94A.941.941,0,0,1,74.75,130.039Zm-4.676,4.676a.94.94,0,1,1,.94-.941A.941.941,0,0,1,70.074,134.715Zm3.96-2.49a.835.835,0,0,1-.834.834h-.865a2.371,2.371,0,0,0-4.522,0h-.866a.835.835,0,0,1-.834-.834v-6.253a.835.835,0,0,1,.834-.834H73.2a.835.835,0,0,1,.834.834v.866a2.371,2.371,0,0,0,0,4.522Zm16.412-4.113a.94.94,0,1,1-.94.94A.941.941,0,0,1,90.447,128.112Zm8.637,4.067a.835.835,0,0,1-.834.834H92a.835.835,0,0,1-.834-.834v-.866a2.373,2.373,0,0,0,1.653-2.382h0a2.376,2.376,0,0,0-1.653-2.139v-.866a.835.835,0,0,1,.834-.834H98.25a.835.835,0,0,1,.834.834Zm0,0'
          transform='translate(-57.762 -111.411)'
          fill='#e20c18'
        />
      </g>
    </svg>
  );
};

export const PhoneIcon = (props: any) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='42.042'
      height='60.06'
      viewBox='0 0 42.042 60.06'
      style={props.style}>
      <g id='outline' transform='translate(-96 -16)'>
        <path
          id='Caminho_15'
          data-name='Caminho 15'
          d='M241,426h2a1,1,0,0,0,0-2h-2a1,1,0,0,0,0,2Z'
          transform='translate(-125.982 -356.949)'
          fill='#e20c18'
        />
        <path
          id='Caminho_16'
          data-name='Caminho 16'
          d='M96.835,58.95a5.513,5.513,0,0,0,1.689,7.4l1.479.987v1.218a3.508,3.508,0,0,0,3.5,3.5h1.048l3.211,3.663a1,1,0,0,0,.753.341h28.522a1,1,0,0,0,.971-1.244l-.971-3.885v-32.2a2.717,2.717,0,0,0-2.714-2.714,5.261,5.261,0,0,0-2.291.522V19.5a3.508,3.508,0,0,0-3.5-3.5H103.507a3.508,3.508,0,0,0-3.5,3.5V37.671l-2.794,3.493a5.523,5.523,0,0,0-.4,6.321,5.514,5.514,0,0,0-.019,5.707,5.518,5.518,0,0,0,.049,5.758Zm1.623-9.744,1.669,1.112a1,1,0,0,0,.216.175l2.689,1.614a1.435,1.435,0,1,1-1.534,2.424l-2.076-1.384a3.506,3.506,0,0,1-.557-.463,1,1,0,0,0-.081-.118,3.5,3.5,0,0,1-.531-3.506C98.32,49.109,98.388,49.159,98.458,49.206Zm3.548-27.2h28.028V38.222a5.264,5.264,0,0,0-1,3.092v10.36l-1.641,1.969a14.542,14.542,0,0,0-3.364,9.292v1.114H105.843a3.441,3.441,0,0,0-1.47-2.06,3.436,3.436,0,0,0-.164-5.788l-.008,0a3.436,3.436,0,0,0,.15-5.61,3.436,3.436,0,0,0-.143-5.8l-2.2-1.322ZM98,56.029a3.522,3.522,0,0,1,.24-1.266c.024.016.046.034.069.05l1.946,1.3a1,1,0,0,0,.233.193l2.689,1.613a1.435,1.435,0,1,1-1.534,2.424l-2.076-1.384A3.512,3.512,0,0,1,98,56.029Zm.066,5.726a3.513,3.513,0,0,1,.23-1.247c.053.038.106.078.16.114l1.963,1.309a1,1,0,0,0,.134.1l2.689,1.614a1.435,1.435,0,1,1-1.534,2.424l-2.076-1.384a3.512,3.512,0,0,1-1.566-2.928Zm5.44,8.3a1.5,1.5,0,0,1-1.5-1.5v-.28a3.43,3.43,0,0,0,3.729-2.223h18.293v4Zm31.532-31.32V71.055a1,1,0,0,0,.03.243l.69,2.76H108.973l-1.755-2h17.811a1,1,0,0,0,1-1V62.935a12.536,12.536,0,0,1,2.9-8.01l1.873-2.247a1,1,0,0,0,.232-.641V41.314a3.3,3.3,0,0,1,3.292-3.292A.713.713,0,0,1,135.039,38.734ZM102.006,19.5a1.5,1.5,0,0,1,1.5-1.5h25.025a1.5,1.5,0,0,1,1.5,1.5V20H102.006ZM98.773,42.414,100,40.875v3.153a1,1,0,0,0,.486.858l2.689,1.613a1.435,1.435,0,1,1-1.534,2.424L99.568,47.54a3.518,3.518,0,0,1-.8-5.125Z'
          transform='translate(0)'
          fill='#e20c18'
        />
        <path
          id='Caminho_17'
          data-name='Caminho 17'
          d='M201,110.014h12.012a1,1,0,0,0,1-1V97a1,1,0,0,0-1-1H201a1,1,0,0,0-1,1v12.012A1,1,0,0,0,201,110.014ZM208.008,98v3.385l-.553-.277a1,1,0,0,0-.9,0l-.553.277V98ZM202,98h2v5.005a1,1,0,0,0,1.449.9l1.554-.777,1.554.777a1,1,0,0,0,1.449-.9V98h2v10.01H202Z'
          transform='translate(-90.987 -69.99)'
          fill='#e20c18'
        />
        <path
          id='Caminho_18'
          data-name='Caminho 18'
          d='M190.893,235.178l7.01,5.706a5.141,5.141,0,0,0,7.232-.742l1.031-1.266a1,1,0,0,0-.145-1.408l-3.731-3.037a1,1,0,0,0-1.044-.136l-1.4.63-3.517-2.863.334-1.5a1,1,0,0,0-.345-.994l-3.731-3.037a1,1,0,0,0-1.408.145l-1.031,1.266a5.141,5.141,0,0,0,.742,7.232Zm.121-4.285a3.128,3.128,0,0,1,.69-1.683l.4-.49,2.475,2.015-.334,1.5a1,1,0,0,0,.345.994l4.477,3.644a1,1,0,0,0,1.044.136l1.4-.63,2.475,2.015-.4.49a3.139,3.139,0,0,1-4.415.453l-7.01-5.706A3.132,3.132,0,0,1,191.013,230.893Z'
          transform='translate(-81.361 -183.995)'
          fill='#e20c18'
        />
      </g>
    </svg>
  );
};

export const QuotesIcon = (props: any) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='251.398'
      height='220.223'
      viewBox='0 0 251.398 220.223'
      style={props.style}>
      <path
        id='Icon_awesome-quote-right'
        data-name='Icon awesome-quote-right'
        d='M226.017,2.25H163.667a23.387,23.387,0,0,0-23.381,23.381V87.981a23.387,23.387,0,0,0,23.381,23.381h38.968v31.175a31.2,31.2,0,0,1-31.175,31.175h-3.9A11.663,11.663,0,0,0,155.874,185.4v23.381a11.662,11.662,0,0,0,11.691,11.691h3.9A77.915,77.915,0,0,0,249.4,142.536V25.631A23.387,23.387,0,0,0,226.017,2.25Zm-140.286,0H23.381A23.387,23.387,0,0,0,0,25.631V87.981a23.387,23.387,0,0,0,23.381,23.381H62.35v31.175a31.2,31.2,0,0,1-31.175,31.175h-3.9A11.662,11.662,0,0,0,15.587,185.4v23.381a11.662,11.662,0,0,0,11.691,11.691h3.9a77.915,77.915,0,0,0,77.937-77.937V25.631A23.387,23.387,0,0,0,85.731,2.25Z'
        transform='translate(1 -1.25)'
        fill='rgba(226,12,24,0.11)'
        stroke='rgba(226,12,24,0.07)'
        strokeWidth='2'
        opacity='0.73'
      />
    </svg>
  );
};

export const PaperIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='46.902'
      height='56.282'
      viewBox='0 0 46.902 56.282'>
      <g id='pie-chart' transform='translate(-2)'>
        <path
          id='Caminho_19'
          data-name='Caminho 19'
          d='M43.039,56.282H7.863A5.871,5.871,0,0,1,2,50.419V5.863A5.871,5.871,0,0,1,7.863,0H43.039A5.871,5.871,0,0,1,48.9,5.863V50.419A5.871,5.871,0,0,1,43.039,56.282ZM7.863,2.345A3.522,3.522,0,0,0,4.345,5.863V50.419a3.522,3.522,0,0,0,3.518,3.518H43.039a3.522,3.522,0,0,0,3.518-3.518V5.863a3.522,3.522,0,0,0-3.518-3.518Z'
          transform='translate(0)'
          fill='#e20c18'
        />
        <path
          id='Caminho_20'
          data-name='Caminho 20'
          d='M21.863,13.345h-4.69a1.173,1.173,0,1,1,0-2.345h4.69a1.173,1.173,0,1,1,0,2.345Z'
          transform='translate(18.831 14.796)'
          fill='#e20c18'
        />
        <path
          id='Caminho_21'
          data-name='Caminho 21'
          d='M21.863,10.345h-4.69a1.173,1.173,0,1,1,0-2.345h4.69a1.173,1.173,0,1,1,0,2.345Z'
          transform='translate(18.831 10.761)'
          fill='#e20c18'
        />
        <path
          id='Caminho_22'
          data-name='Caminho 22'
          d='M21.863,16.345h-4.69a1.173,1.173,0,1,1,0-2.345h4.69a1.173,1.173,0,1,1,0,2.345Z'
          transform='translate(18.831 18.831)'
          fill='#e20c18'
        />
        <path
          id='Caminho_23'
          data-name='Caminho 23'
          d='M21.863,19.345h-4.69a1.173,1.173,0,1,1,0-2.345h4.69a1.173,1.173,0,1,1,0,2.345Z'
          transform='translate(18.831 22.866)'
          fill='#e20c18'
        />
        <path
          id='Caminho_24'
          data-name='Caminho 24'
          d='M36.659,22.345H6.173a1.173,1.173,0,1,1,0-2.345H36.659a1.173,1.173,0,1,1,0,2.345Z'
          transform='translate(4.035 26.902)'
          fill='#e20c18'
        />
        <path
          id='Caminho_25'
          data-name='Caminho 25'
          d='M16.725,31.451A11.725,11.725,0,1,1,28.451,19.725,11.739,11.739,0,0,1,16.725,31.451Zm0-21.106a9.38,9.38,0,1,0,9.38,9.38A9.39,9.39,0,0,0,16.725,10.345Z'
          transform='translate(4.035 10.761)'
          fill='#e20c18'
        />
        <path
          id='Caminho_26'
          data-name='Caminho 26'
          d='M7.491,28.36a1.171,1.171,0,0,1-.83-2l7.12-7.12V9.173a1.173,1.173,0,1,1,2.345,0V19.725a1.181,1.181,0,0,1-.342.83L8.321,28.018A1.178,1.178,0,0,1,7.491,28.36Z'
          transform='translate(5.808 10.761)'
          fill='#e20c18'
        />
      </g>
    </svg>
  );
};

export const LightIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='47.581'
      height='59'
      viewBox='0 0 47.581 59'>
      <g id='solution' transform='translate(-7 -1)'>
        <path
          id='Caminho_27'
          data-name='Caminho 27'
          d='M52.984,1H39.661a2.858,2.858,0,0,0-2.855,2.855v1.9a3.806,3.806,0,1,0,0,7.613v4.758h7.613v-1.9a1.9,1.9,0,0,1,3.806,0v1.9h4.758a2.858,2.858,0,0,0,2.855-2.855V3.855A2.858,2.858,0,0,0,52.984,1Zm.952,14.274a.953.953,0,0,1-.952.952H50.129a3.806,3.806,0,1,0-7.613,0H38.71V11.468h-1.9a1.9,1.9,0,1,1,0-3.806h1.9V3.855a.953.953,0,0,1,.952-.952H52.984a.953.953,0,0,1,.952.952Z'
          transform='translate(-1.258)'
          fill='#e20c18'
        />
        <path
          id='Caminho_28'
          data-name='Caminho 28'
          d='M35.548,20.323a3.81,3.81,0,0,0-3.806,3.806H27.935V19.371h-1.9a1.9,1.9,0,1,1,0-3.806h1.9V7H25.384A18.384,18.384,0,0,0,13.743,39.613l3.725,3.048v2.58a2.839,2.839,0,0,0,.209,5.424,2.827,2.827,0,0,0,1.745,3.757,6.657,6.657,0,0,0,13.22,0,2.828,2.828,0,0,0,1.745-3.758A2.839,2.839,0,0,0,34.6,45.24V42.66l3.725-3.048a18.313,18.313,0,0,0,6.743-14.228V24.129h-5.71A3.81,3.81,0,0,0,35.548,20.323ZM25.384,8.9h.648v4.758a3.806,3.806,0,1,0,0,7.613v2.855H22.226a3.806,3.806,0,0,0-7.613,0H8.951A16.5,16.5,0,0,1,25.384,8.9ZM14.948,38.14A16.41,16.41,0,0,1,8.917,26.032h7.6v-1.9a1.9,1.9,0,0,1,3.806,0v1.9h5.71v3.806a3.806,3.806,0,0,0,0,7.613v7.613H19.371V41.759ZM26.032,58.387a4.767,4.767,0,0,1-4.662-3.806h9.324A4.767,4.767,0,0,1,26.032,58.387Zm5.71-5.71H20.323a.952.952,0,0,1,0-1.9H31.742a.952.952,0,1,1,0,1.9Zm1.9-3.806H18.419a.952.952,0,1,1,0-1.9H33.645a.952.952,0,1,1,0,1.9ZM37.117,38.14l-4.423,3.619v3.306H27.935V35.548h-1.9a1.9,1.9,0,0,1,0-3.806h1.9v-5.71h5.71v-1.9a1.9,1.9,0,0,1,3.806,0v1.9h5.7A16.41,16.41,0,0,1,37.117,38.14Z'
          transform='translate(0 -0.29)'
          fill='#e20c18'
        />
      </g>
    </svg>
  );
};

export const CoinIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='57.159'
      height='56.489'
      viewBox='0 0 57.159 56.489'>
      <g id='money' transform='translate(0 -3)'>
        <g
          id='Grupo_19'
          data-name='Grupo 19'
          transform='translate(33.487 31.267)'>
          <g id='Grupo_18' data-name='Grupo 18'>
            <path
              id='Caminho_29'
              data-name='Caminho 29'
              d='M304.643,264.257a2.148,2.148,0,1,1,2.456-2.126,1.116,1.116,0,0,0,2.233,0,4.442,4.442,0,0,0-3.572-4.233v-.581a1.116,1.116,0,1,0-2.233,0v.581a4.442,4.442,0,0,0-3.572,4.233,4.538,4.538,0,0,0,4.689,4.358,2.148,2.148,0,1,1-2.456,2.126,1.116,1.116,0,0,0-2.233,0,4.442,4.442,0,0,0,3.572,4.233v.482a1.116,1.116,0,1,0,2.233,0v-.482a4.442,4.442,0,0,0,3.572-4.233A4.538,4.538,0,0,0,304.643,264.257Z'
              transform='translate(-299.954 -256.201)'
              fill='#e20c18'
            />
          </g>
        </g>
        <g
          id='Grupo_21'
          data-name='Grupo 21'
          transform='translate(42.861 27.313)'>
          <g id='Grupo_20' data-name='Grupo 20'>
            <path
              id='Caminho_30'
              data-name='Caminho 30'
              d='M391.466,226.154a14.546,14.546,0,0,0-5.942-5.258,1.116,1.116,0,1,0-.967,2.012,12.291,12.291,0,0,1,5.536,16.834,1.116,1.116,0,1,0,1.971,1.049,14.529,14.529,0,0,0-.6-14.637Z'
              transform='translate(-383.924 -220.785)'
              fill='#e20c18'
            />
          </g>
        </g>
        <g
          id='Grupo_23'
          data-name='Grupo 23'
          transform='translate(38.739 25.998)'>
          <g id='Grupo_22' data-name='Grupo 22'>
            <path
              id='Caminho_31'
              data-name='Caminho 31'
              d='M348.192,209h-.075a1.116,1.116,0,0,0,0,2.233h.07a1.116,1.116,0,0,0,.005-2.233Z'
              transform='translate(-347 -209.001)'
              fill='#e20c18'
            />
          </g>
        </g>
        <g
          id='Grupo_25'
          data-name='Grupo 25'
          transform='translate(23.668 33.11)'>
          <g id='Grupo_24' data-name='Grupo 24'>
            <path
              id='Caminho_32'
              data-name='Caminho 32'
              d='M221.2,291.186a12.291,12.291,0,0,1-5.536-16.834A1.116,1.116,0,0,0,213.7,273.3a14.519,14.519,0,0,0,6.539,19.9,1.116,1.116,0,1,0,.967-2.012Z'
              transform='translate(-212.002 -272.711)'
              fill='#e20c18'
            />
          </g>
        </g>
        <g
          id='Grupo_27'
          data-name='Grupo 27'
          transform='translate(35.32 52.791)'>
          <g id='Grupo_26' data-name='Grupo 26'>
            <path
              id='Caminho_33'
              data-name='Caminho 33'
              d='M317.564,449H317.5a1.116,1.116,0,0,0-.01,2.233h.075a1.116,1.116,0,0,0,0-2.233Z'
              transform='translate(-316.378 -448.999)'
              fill='#e20c18'
            />
          </g>
        </g>
        <g id='Grupo_29' data-name='Grupo 29' transform='translate(0 3)'>
          <g id='Grupo_28' data-name='Grupo 28' transform='translate(0 0)'>
            <path
              id='Caminho_34'
              data-name='Caminho 34'
              d='M43.25,22.221a5.125,5.125,0,0,0-.5-.912H45.66a5.135,5.135,0,0,0,0-10.271H36.72A5.132,5.132,0,0,0,32.487,3H5.135a5.135,5.135,0,1,0,0,10.271h8.94a5.121,5.121,0,0,0,0,5.805H11.164A5.132,5.132,0,0,0,7.973,28.23a5.126,5.126,0,0,0,0,8.038,5.126,5.126,0,0,0,0,8.038,5.132,5.132,0,0,0,3.191,9.154H24.321A18.974,18.974,0,1,0,43.25,22.221Zm2.41-8.95a2.9,2.9,0,0,1,0,5.805H18.309a2.9,2.9,0,0,1,0-5.805ZM5.135,11.038a2.9,2.9,0,1,1,0-5.805H32.487a2.9,2.9,0,1,1,0,5.805Zm6.028,10.271H38.515a2.9,2.9,0,0,1,1.267.292c-.528-.044-1.062-.068-1.6-.068a18.92,18.92,0,0,0-13.43,5.582H11.164a2.9,2.9,0,1,1,0-5.805Zm0,8.038H22.843a18.925,18.925,0,0,0-2.869,5.805h-8.81a2.9,2.9,0,1,1,0-5.805Zm0,8.038h8.3a18.994,18.994,0,0,0-.069,5.805H11.164a2.9,2.9,0,0,1,0-5.805Zm0,13.843a2.9,2.9,0,1,1,0-5.805h8.684a18.9,18.9,0,0,0,2.679,5.805Zm27.017,6.029A16.746,16.746,0,1,1,54.926,40.511,16.765,16.765,0,0,1,38.181,57.257Z'
              transform='translate(0 -3)'
              fill='#e20c18'
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const PlayIcon = (props: any) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='190'
      height='190'
      viewBox='0 0 190 190'
      style={props.style}>
      <g
        id='Grupo_1353'
        data-name='Grupo 1353'
        transform='translate(-865 -3617)'>
        <circle
          id='Elipse_10'
          data-name='Elipse 10'
          cx='95'
          cy='95'
          r='95'
          transform='translate(865 3617)'
          fill='#fff'
          opacity='0.4'
        />
        <circle
          id='Elipse_11'
          data-name='Elipse 11'
          cx='75'
          cy='75'
          r='75'
          transform='translate(885 3637)'
          fill='#fff'
        />
        <path
          id='Icon_ionic-ios-play'
          data-name='Icon ionic-ios-play'
          d='M9,7.593V38.409a.793.793,0,0,0,1.188.731L34.616,23.732a.873.873,0,0,0,0-1.452L10.188,6.871A.786.786,0,0,0,9,7.593Z'
          transform='translate(938 3689.249)'
          fill='#e20c18'
        />
      </g>
    </svg>
  );
};
